import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AchievementCard from './AchievementCard';

const AchievementsDisplay = ({ achievements, calculatedDays, language }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [showAll, setShowAll] = useState(false);
  
  // Process achievements data
  const processedAchievements = achievements.map(achievement => {
    const isAchieved = calculatedDays >= achievement.days;
    return {
      ...achievement,
      isAchieved
    };
  });
  
  // Filter achievements based on active filter
  const getFilteredAchievements = () => {
    let filtered = [];
    
    switch (activeFilter) {
      case 'upcoming':
        filtered = processedAchievements.filter(a => !a.isAchieved);
        break;
      case 'achieved':
        filtered = processedAchievements.filter(a => a.isAchieved);
        break;
      case 'special':
        filtered = processedAchievements.filter(a => a.special);
        break;
      default:
        filtered = processedAchievements;
    }
    
    return showAll ? filtered : filtered.slice(0, 9);
  };
  
  // Check if there are more items to show
  const hasMoreItems = processedAchievements.length > 9;
  const filteredAchievements = getFilteredAchievements();
  
  return (
    <div className="achievements-display">
      {/* Filter Tabs */}
      <div className="flex justify-end mb-4">
        <div className="inline-flex bg-white dark:bg-gray-750 rounded-lg p-1 shadow-sm border border-gray-200 dark:border-gray-700">
          <button 
            className={`px-3 py-1 text-sm rounded-md transition-colors ${
              activeFilter === 'all' ? 
              'bg-love-100 dark:bg-love-900 text-love-700 dark:text-love-300 font-medium' : 
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
            onClick={() => setActiveFilter('all')}
          >
            {language === 'zh' ? '全部' : 'All'}
          </button>
          <button 
            className={`px-3 py-1 text-sm rounded-md transition-colors ${
              activeFilter === 'upcoming' ? 
              'bg-love-100 dark:bg-love-900 text-love-700 dark:text-love-300 font-medium' : 
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
            onClick={() => setActiveFilter('upcoming')}
          >
            {language === 'zh' ? '即將到來' : 'Upcoming'}
          </button>
          <button 
            className={`px-3 py-1 text-sm rounded-md transition-colors ${
              activeFilter === 'achieved' ? 
              'bg-love-100 dark:bg-love-900 text-love-700 dark:text-love-300 font-medium' : 
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
            onClick={() => setActiveFilter('achieved')}
          >
            {language === 'zh' ? '已達成' : 'Achieved'}
          </button>
          <button 
            className={`px-3 py-1 text-sm rounded-md transition-colors ${
              activeFilter === 'special' ? 
              'bg-love-100 dark:bg-love-900 text-love-700 dark:text-love-300 font-medium' : 
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
            onClick={() => setActiveFilter('special')}
          >
            {language === 'zh' ? '特殊紀念' : 'Special'}
          </button>
        </div>
      </div>

      {filteredAchievements.length > 0 ? (
        <>
          {/* Achievement Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <AnimatePresence>
              {filteredAchievements.map((achievement, index) => (
                <AchievementCard
                  key={achievement.id}
                  achievement={achievement}
                  isAchieved={achievement.isAchieved}
                  language={language}
                  index={index}
                />
              ))}
            </AnimatePresence>
          </div>
          
          {/* Show More/Less Button */}
          {hasMoreItems && (
            <div className="flex justify-center mt-4">
              <motion.button
                onClick={() => setShowAll(!showAll)}
                className="px-4 py-2 bg-white dark:bg-gray-750 border border-love-200 dark:border-love-800 rounded-full text-sm text-love-600 dark:text-love-400 hover:bg-love-50 dark:hover:bg-love-900/20 transition-colors shadow-sm"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                {showAll ? 
                  (language === 'zh' ? '顯示較少' : 'Show Less') : 
                  (language === 'zh' ? '顯示更多' : 'Show More')}
              </motion.button>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-500 dark:text-gray-400">
            {language === 'zh' ? '沒有符合條件的成就' : 'No achievements match your filter'}
          </p>
        </div>
      )}
    </div>
  );
};

export default AchievementsDisplay;